const EditIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke=""
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.16602 3.33417H3.33268C2.89065 3.33417 2.46673 3.50977 2.15417 3.82233C1.84161 4.13489 1.66602 4.55881 1.66602 5.00084V16.6675C1.66602 17.1095 1.84161 17.5335 2.15417 17.846C2.46673 18.1586 2.89065 18.3342 3.33268 18.3342H14.9993C15.4414 18.3342 15.8653 18.1586 16.1779 17.846C16.4904 17.5335 16.666 17.1095 16.666 16.6675V10.8342M15.416 2.08417C15.7475 1.75265 16.1972 1.56641 16.666 1.56641C17.1349 1.56641 17.5845 1.75265 17.916 2.08417C18.2475 2.41569 18.4338 2.86533 18.4338 3.33417C18.4338 3.80301 18.2475 4.25265 17.916 4.58417L9.99935 12.5008L6.66602 13.3342L7.49935 10.0008L15.416 2.08417Z"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default EditIcon
